import { useTypedSelector } from '../store/store';

export const useImportWizard = () => {
  const wizard = useTypedSelector((state) => state.superAppImportWizard);
  return wizard;
};
